export default "__VITE_ASSET__C24dEVOg__"